export const SET_ITEM_PROPERTIES = "SET_ITEM_PROPERTIES";

export default function setItemProperties(itemProperties) {
    return dispatch => dispatch({
        type: SET_ITEM_PROPERTIES,
        itemProperties
    })
}